addEventListener('turbo:before-cache', () => {
	for (let element of document.querySelectorAll('.toast')) {
		element.parentNode.removeChild(element)
	}
})
